<p-table #table
    [value]="galleria"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm"
    [paginator]="true"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    [globalFilterFields]="['file']"
    currentPageReportTemplate="{first} di {last} su {totalRecords} file"
    [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca file…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="add = true">
                    <i class="bi bi-plus"></i>
                    Aggiungi files
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w-1/12"></th>
            <th class="w-2/12">Anteprima</th>
            <th class="w-7/12">File</th>
            <th class="w-2/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-file let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
            </td>
            <td class="gal-thumb-cell">
                <span class="p-column-title">Anteprima</span>
                <div class="gal-thumb">
                    @if (file.type === 'image' || file.file_base64) {
                        <img
                            #thumb
                            [src]="thumbSrc(file)"
                            alt=""
                            loading="lazy"
                            (error)="thumb.src = '../../../../../assets/images/Noimage.png'"
                        />
                    } @else {
                        <div class="gal-thumb-video" aria-hidden="true">
                            <i class="bi bi-play-btn"></i>
                        </div>
                    }
                </div>
            </td>
            <td>
                <span class="p-column-title">File</span>
                <span class="cell-nome">{{ file.file }}</span>
                @if (file.evidenza) {
                    <span class="gal-badge">in evidenza</span>
                }
            </td>
            <td class="text-center" *ngIf="!file.file_upload && !file.file_base64">
                <div class="table-actions">
                    <i class="bi bi-pencil" (click)="onOpenEdit(file)" *ngIf="file.type !== 'image'" pTooltip="Modifica" tooltipPosition="bottom"></i>
                    <p-divider layout="vertical" *ngIf="file.type !== 'image'"></p-divider>
                    <a [href]="file.file_base64 ? file.file_base64 : (file.file + '?type=' + file.type | file)" target="_blank">
                        <i class="bi" [ngClass]="{'bi-card-image': file.type === 'image', 'bi-play-btn': file.type !== 'image' }"></i>
                    </a>
                    <p-divider layout="vertical"></p-divider>
                    <p-confirmPopup #deleteGallery>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDelete()">Annulla</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <i class="bi bi-trash" (click)="onOpenDelete($event, file, index)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                </div>
            </td>
            <td class="text-center" *ngIf="file.file_upload || file.file_base64">
                <div class="table-actions">
                    <i class="bi bi-trash" (click)="onRemoveFileGalleria(file)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">Nessuno file presente nella galleria.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [visible]="add" [style]="{width: '70%'}" header="Aggiungi files alla galleria" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">
        @if (!add_files && !add_image) {
            <div class="acc-actions full">
                <button type="button" class="acc-btn" (click)="add_files = true">Aggiungi uno o più file</button>
                <button type="button" class="acc-btn" (click)="add_image = true">Aggiungi un'immagine e ritaglia</button>
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal();">Annulla</button>
            </div>
        }

        @if (add_files) {
            <div class="accrediti-form flex flex-col gap-6">
                <app-file-upload
                    [form]="formUpload"
                    [control]="'files'"
                    [label]="''"
                    [multiple]="true"
                    [accept]="'image/*,video/*'"
                    [text]="'Trascina qui i file'"
                    (load)="onFilesLoad($event)">
                </app-file-upload>
                <div class="acc-actions">
                    <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal();">Annulla</button>
                    <button type="button" class="acc-btn" (click)="add_files = false">Indietro</button>
                    <button type="button" class="acc-btn acc-btn-primary" [disabled]="files.length <= 0" (click)="onAddFilesGalleria(files)">Aggiungi</button>
                </div>
            </div>
        }

        @if (add_image) {
            <div class="accrediti-form flex flex-col gap-6">
                <app-image-cropper [type]="'box'" [aspect_ratio]="1/1" [height]="550" [width]="450" accept="image/*" (onCrop)="immagine=$event"></app-image-cropper>
                <div class="acc-actions">
                    <button type="button" class="acc-btn acc-btn-ghost" (click)="add_image = false; immagine=''">Annulla</button>
                    <button type="button" class="acc-btn" (click)="add_image = false">Indietro</button>
                    <button type="button" class="acc-btn acc-btn-primary" [disabled]="immagine.length <= 0" (click)="onAddFileGalleria(immagine)">Ritaglia</button>
                </div>
            </div>
        }
    </ng-template>
</p-dialog>

<p-dialog [visible]="edit" [style]="{width: '50%'}" header="Modifica video galleria" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">
        <form [formGroup]="formGalleria" class="accrediti-form flex flex-col gap-6">
            <p-checkbox class="flex" label="Mostra in evidenza" formControlName="evidenza" value="evidenza" pTooltip="Se selezionato, in caso lo spettacolo sia impostato come in 'evidenzia' verrà mostrato il seguente video al posto della copertina in Home page!" tooltipPosition="top" />
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal();">Annulla</button>
                <button type="button" class="acc-btn acc-btn-primary" (click)="onEdit()">Modifica</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
